import isDev from 'Helpers/isDev';
import Sentry from 'Integrations/Sentry';

/**
 * @example return throwInDevOutsideReact('it blew up') ?? valueToUseInProd
 */
export default function throwInDevOutsideReact(msg) {
  if (isDev()) throw (typeof msg === 'string' ? new Error(msg) : msg);
  Sentry.createSentryErrorLog(new Error(msg));
}
